import { useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV_LINKS, REGISTRATION_URL } from "./data";

export const Header = () => {
    const [open, setOpen] = useState(false);
    return (
        <header className="sticky top-0 z-50 bg-[#071B37]/90 backdrop-blur-xl border-b border-[#DDB56C]/15" data-testid="site-header">
            <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 lg:px-8">
                <a href="#hero" className="font-accent text-lg font-semibold tracking-[0.18em] text-white" data-testid="nav-logo">
                    CICI <span className="text-gold">DEVELOPER</span>
                </a>
                <nav className="hidden items-center gap-8 lg:flex" data-testid="nav-menu">
                    {NAV_LINKS.map((l) => (
                        <a key={l.href} href={l.href} data-testid={l.testId}
                            className="text-sm font-medium text-white/75 transition-colors duration-200 hover:text-[#DDB56C]">
                            {l.label}
                        </a>
                    ))}
                </nav>
                <div className="flex items-center gap-3">
                    <a href={REGISTRATION_URL} target="_blank" rel="noopener noreferrer" data-testid="nav-cta-daftar"
                        className="hidden rounded-full bg-[#DDB56C] px-6 py-2.5 text-sm font-bold text-[#071B37] shadow-[0_4px_20px_rgba(221,181,108,0.35)] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#e9cf9a] sm:inline-block">
                        Daftar Sekarang
                    </a>
                    <button onClick={() => setOpen(!open)} aria-label="Buka menu" data-testid="nav-mobile-toggle"
                        className="rounded-lg border border-white/15 p-2 text-white lg:hidden">
                        {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
                    </button>
                </div>
            </div>
            {open && (
                <nav className="border-t border-white/10 bg-[#071B37] px-5 py-4 lg:hidden" data-testid="nav-mobile-menu">
                    <div className="flex flex-col gap-1">
                        {NAV_LINKS.map((l) => (
                            <a key={l.href} href={l.href} onClick={() => setOpen(false)} data-testid={`mobile-${l.testId}`}
                                className="rounded-lg px-3 py-3 text-sm font-medium text-white/80 transition-colors hover:bg-white/5 hover:text-[#DDB56C]">
                                {l.label}
                            </a>
                        ))}
                        <a href={REGISTRATION_URL} target="_blank" rel="noopener noreferrer" data-testid="mobile-nav-cta-daftar"
                            className="mt-2 rounded-full bg-[#DDB56C] px-6 py-3 text-center text-sm font-bold text-[#071B37]">
                            Daftar Sekarang
                        </a>
                    </div>
                </nav>
            )}
        </header>
    );
};
